import { apiHelper } from '@/utils';
import { API } from '@/constants';

const URL = `${API.BASE_URL_API}/v1/configurations`;

export const configurationService = { getAll, show, update, updateStatus };

export function getAll(filter = {}) {
    const params = {
        page: filter.pageNumber,
        size: filter.pageSize,
        key: filter.key || undefined,
        is_active: filter.isActive === '' ? undefined : filter.isActive,
        sortBy: filter.sortBy,
        orderBy: filter.orderBy,
    };
    return apiHelper(URL).get('', { params });
}

export function show(uuid) {
    return apiHelper(URL).get(`/${uuid}`);
}

export function update(data) {
    return apiHelper(URL).put(`/${data.uuid}`, {
        key: data.key,
        number: Number(data.number),
        key_value_type: Number(data.keyValueType),
        key_value_hint: data.keyValueHint || null,
        is_active: Boolean(data.isActive),
        values: data.values.map((item) => ({
            ...(item.uuid ? { uuid: item.uuid } : {}),
            value: item.value,
            is_active: Boolean(item.isActive),
        })),
    });
}

export function updateStatus(uuid, isActive) {
    return apiHelper(URL).patch(`/${uuid}/status`, { is_active: Boolean(isActive) });
}
